import { Link, useLocation } from "react-router-dom";
import { LockKey, Plus } from "@phosphor-icons/react";

export default function Header() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header
      data-testid="app-header"
      className="border-b border-foreground/15 bg-background/80 backdrop-blur sticky top-0 z-30"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <div className="w-8 h-8 bg-foreground text-background flex items-center justify-center">
            <LockKey size={18} weight="bold" />
          </div>
          <div className="leading-none">
            <div className="font-display text-lg font-bold tracking-tight">
              EMERGENT
            </div>
            <div className="label-overline mt-0.5">Zero-Knowledge Paste</div>
          </div>
        </Link>

        <div className="flex items-center gap-3">
          <div
            className="hidden md:flex items-center gap-2 text-xs font-mono text-muted-foreground"
            data-testid="encryption-indicator"
          >
            <span className="inline-block w-1.5 h-1.5 bg-secure rounded-full animate-pulse-dot" />
            AES-256-GCM · DUAL LAYER
          </div>
          {!isHome && (
            <Link
              to="/"
              data-testid="header-new-paste-btn"
              className="inline-flex items-center gap-2 px-4 h-10 border border-foreground bg-foreground text-background text-xs font-bold uppercase tracking-[0.18em] hover:bg-neutral-800 transition-colors"
            >
              <Plus size={14} weight="bold" />
              New Paste
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
